import React, { Fragment } from 'react'

import { Block, Button, Flex, Grid, H2, ImageBlock, P } from '../../../../components/basic'
import { Blue, Blue_400 } from '../../../../constants/colors'

export const Popup = ({
    firstOptionText,
    handleFirstOptionClick,
    handleSecondOptionClick,
    imageSrc,
    label,
    message,
    mobile,
    secondOptionText,
    title
}) => {
    return (
        <>
            <Fragment>
                <Grid columns={mobile ? '100%' : '70% 30%'}>
                    <Block margin="20px 0 0 0">
                        <H2 margin="0 0 20px 0">{title}</H2>
                        <P margin="10px 0 30px 0">{message}</P>
                        <P margin="10px 0 30px 0">{label}</P>
                        <Flex
                            justify="left"
                            borderLeft={mobile && "1px solid lightgray"}
                            width="auto"
                        >
                            <Block width="auto" margin="0 10px 0 0">
                                <Button
                                    onClick={handleFirstOptionClick}
                                    fontSize="12px"
                                    margin="10px 0 0 0"
                                    hoverBackground={!mobile ? Blue : Blue_400}
                                    border="2px solid"
                                    borderColor={!mobile ? Blue : Blue_400}
                                    padding={mobile && "15px 20px"}
                                    background={!mobile ? Blue : Blue_400}
                                >
                                    <Fragment>
                                        {firstOptionText}
                                    </Fragment>
                                </Button>
                            </Block>
                            <Block width="auto" margin="0 10px 0 0">
                                <Button
                                    onClick={handleSecondOptionClick}
                                    fontSize="12px"
                                    margin="0 0 10px 0"
                                    hoverBackground={!mobile ? Blue : Blue_400}
                                    border="2px solid"
                                    borderColor={!mobile ? Blue : Blue_400}
                                    padding={mobile && "15px 20px"}
                                    background={!mobile ? Blue : Blue_400}
                                >
                                    <Fragment>
                                        {secondOptionText}
                                    </Fragment>
                                </Button>
                            </Block>
                        </Flex>
                    </Block>
                    <Block margin="20px 0 0 10px">
                        <ImageBlock width="250" height="280" src={imageSrc} />
                    </Block>
                </Grid>
            </Fragment>
        </>
    )
}